export default __webpack_public_path__ + "static/media/gallery-20.73629234.jpg";